var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41325 1.66659L9.63325 2.99992H12.3333V10.9999H1.66659V2.99992H4.36659L5.58659 1.66659H8.41325ZM8.99992 0.333252H4.99992L3.77992 1.66659H1.66659C0.933252 1.66659 0.333252 2.26659 0.333252 2.99992V10.9999C0.333252 11.7333 0.933252 12.3333 1.66659 12.3333H12.3333C13.0666 12.3333 13.6666 11.7333 13.6666 10.9999V2.99992C13.6666 2.26659 13.0666 1.66659 12.3333 1.66659H10.2199L8.99992 0.333252ZM6.99992 4.99992C8.09992 4.99992 8.99992 5.89992 8.99992 6.99992C8.99992 8.09992 8.09992 8.99992 6.99992 8.99992C5.89992 8.99992 4.99992 8.09992 4.99992 6.99992C4.99992 5.89992 5.89992 4.99992 6.99992 4.99992ZM6.99992 3.66659C5.15992 3.66659 3.66659 5.15992 3.66659 6.99992C3.66659 8.83992 5.15992 10.3333 6.99992 10.3333C8.83992 10.3333 10.3333 8.83992 10.3333 6.99992C10.3333 5.15992 8.83992 3.66659 6.99992 3.66659Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraWhite);
export default __webpack_public_path__ + "static/media/icon_camera_white.563c737758dd8b5e19396aea15b9ac97.svg";
export { ForwardRef as ReactComponent };